import { render } from "./PodUpdate.vue?vue&type=template&id=f581b44a&scoped=true"
import script from "./PodUpdate.vue?vue&type=script&lang=js"
export * from "./PodUpdate.vue?vue&type=script&lang=js"

import "./PodUpdate.vue?vue&type=style&index=0&id=f581b44a&scoped=true&lang=less"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f581b44a"]])

export default __exports__